import React, { useState, Component } from "react";
import useStyles from "./styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Rating from "@material-ui/lab/Rating";
import { Link } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

//Icons import
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";

//Files import
import { useCartContext, addProductToCart } from "../../context/CartContext";
import {
  useWishlistContext,
  addProductToWishlist,
} from "../../context/WishlistContext";

// MUI Components
import { Button, Tooltip, Typography } from "@material-ui/core";

export default function ProductCard(props) {
  const classes = useStyles();
  // context
  const { dispatch, cartProducts } = useCartContext();
  const { wishlistDispatch, wishlistProducts } = useWishlistContext();
  const [outOfStockError, setOutOfStockError] = useState(null);
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const addItemToCart = () => {
    let cartItem = { ...props, quantity: 1 };
    if (cartProducts === "null" || cartProducts === null) {
      if (cartItem.stockAvailable >= 1) {
        window.location.reload(false);
        return addProductToCart(dispatch, [cartItem]);
      } else {
        setOutOfStockError("Out of Stock!");
        return;
      }
    } else {
      if (!cartProducts.filter((e) => e._id === cartItem._id).length > 0) {
        if (cartItem.stockAvailable >= 1) {
          let temp = cartProducts;
          temp.push(cartItem);
          window.location.reload(false);
          return addProductToCart(dispatch, temp);
        } else {
          setOutOfStockError("Out of Stock!");
          return;
        }
      } else {
        cartProducts.forEach((product) => {
          if (product._id === cartItem._id) {
            if (product.color === cartItem.color) {
              if (product.stockAvailable >= product.quantity + 1) {
                product.quantity += 1;
                window.location.reload(false);
              } else {
                setOutOfStockError("Out of Stock!");
                return;
              }
            } else {
              if (product.stockAvailable >= product.quantity + 1) {
                let temp = cartProducts;
                temp.push(cartItem);
                window.location.reload(false);
                return addProductToCart(dispatch, temp);
              } else {
                setOutOfStockError("Out of Stock!");
                return;
              }
            }
          }
        });
        let temp = cartProducts;
        return addProductToCart(dispatch, temp);
      }
      // console.log("cart Products", cartProducts)
    }
  };

  const addItemToWishlist = () => {
    const wishlistProduct = { ...props, quantity: 1 };

    if (wishlistProducts === "null" || wishlistProducts === null) {
      window.location.reload(false);
      return addProductToWishlist(wishlistDispatch, [wishlistProduct]);
    } else {
      if (
        !wishlistProducts.filter((e) => e._id === wishlistProduct._id).length >
        0
      ) {
        window.location.reload(false);
        let temp = wishlistProducts;
        temp.push(wishlistProduct);
        return addProductToWishlist(wishlistDispatch, temp);
      } else {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Product already present in wishlist. ",
          open: true,
        });
      }
    }
  };
  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      {/* DEAL PRODUCTS CARDS */}
      <Card className={classes.cardMainBox}>
        <Link
          to={`/product?productId=${props._id}`}
          className={classes.actionArea}
        >
          <img
            className={classes.media}
            src={props.image}
            title={props.title}
          />
          <CardContent style={{ paddingBottom: 1 }}>
          <Tooltip title={props.category}>
            <Typography
              className={classes.categoryText}
              variant="body2"
              color="textSecondary"
              component="p"
              noWrap
            >
              {props.category}
            </Typography>
            </Tooltip>
            <Tooltip title={props.title}>
            <Typography
              className={classes.titleText}
              noWrap
              gutterBottom
              variant="h6"
              component="p"
            >
              {props.title}
            </Typography>
            </Tooltip>
            <div className={classes.pricesBox} style={{ display: "flex" }}>
              <Typography
                className={classes.priceText}
                gutterBottom
                style={{ marginRight: 8 }}
                variant="h5"
                component="p"
                noWrap
              >
                Rs. {props.price}
              </Typography>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classes.cutPriceText}
                  variant="h6"
                  color="textSecondary"
                  style={{ color: "#999" }}
                  component="p"
                  noWrap
                >
                  {props.cutPrice ? "Rs. " + props.cutPrice : ""}
                </Typography>
                {!props.cutPrice ? (
                  <Typography
                  className={classes.cutPriceText}
                  variant="h6"
                    style={{
                      color: "white",
                      textDecoration: "none",
                      textDecorationColor: "none",
                    }}
                  >
                    Rs. {props.price}
                  </Typography>
                ) : null}

                <Typography
                  variant="p"
                  color="textSecondary"
                  style={{ marginLeft: 4, marginTop: 2 }}
                >
                  {props.discountPercentage
                    ? "-" + props.discountPercentage + "%"
                    : ""}
                </Typography>
              </div>
            </div>
            <div className={classes.ratingBox}>
              <Rating
                name="half-rating-read"
                defaultValue={props.rating}
                //className={classes.ratingStars}
                style={{ fontSize: 15 }}
                precision={0.5}
                readOnly
              />
              <Typography variant="p" style={{ fontSize: 13, color: "#666" }}>
                ({Math.round(props.totalRatingStars)})
              </Typography>
              <Typography style={{ fontSize: 12, color: "red" }}>
                {outOfStockError ? `(${outOfStockError})` : null}
              </Typography>
            </div>
          </CardContent>
        </Link>
        <CardActions
          style={{ display: "flex", justifyContent: "space-between"}}
          className={classes.CardActionsDiv}
        >
          <Button
            onClick={addItemToCart}
            className={classes.productBtn}
            size="small"
            color="primary"
          >
            <AddShoppingCartIcon fontSize="small" className={classes.wishListIcon} />
            Cart
          </Button>
          <Button
            onClick={addItemToWishlist}
            className={classes.wishlistBtn}
            size="small"
            color="primary"
          >
            <FavoriteBorderIcon className={classes.wishListIcon} fontSize="small"  />
            WishList
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}
